module.exports = __webpack_public_path__ + "img/139-71075a.png";